import { render, staticRenderFns } from "./BaubesichtigungsterminIcon.vue?vue&type=template&id=4bed9a1b&scoped=true"
import script from "./BaubesichtigungsterminIcon.vue?vue&type=script&lang=js"
export * from "./BaubesichtigungsterminIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bed9a1b",
  null
  
)

export default component.exports